import { combineReducers } from '@reduxjs/toolkit';
import getLevelReducer from './get-level';

const levelReducer = combineReducers({
  getLevel: getLevelReducer
});

export default levelReducer;